import React from 'react'
import Footer from './include/Footer'
import Header from './include/Header'
import { Link } from 'react-router-dom'
function Contact() {
  return (
    <>
      <Header />
      <div className="page-header bg-section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="wow fadeInUp" data-cursor="-opaque">Contact <span>us</span></h1>
             {/*    <nav className="wow fadeInUp" data-wow-delay="0.2s">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item"><Link to="/">home</Link></li>
                    <li className="breadcrumb-item active" aria-current="page">contact us</li>
                  </ol>
                </nav> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="page-contact-us">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="contact-us-content">
                <div className="section-title">
                  <h3 className="wow fadeInUp">contact us</h3>
                  <h2 className="wow fadeInUp" data-wow-delay="0.2s" data-cursor="-opaque">Reach out and discover smart <span>AI solutions</span></h2>
                  <p className="wow fadeInUp" data-wow-delay="0.4s">We help businesses unlock their full potential by delivering intelligent AI solutions tailored to their challenges.</p>
                </div>
                <div className="contact-info-body">
                  <div className="contact-info-item wow fadeInUp" data-wow-delay="0.6s">
                    <div className="icon-box">
                      <img src="images/icon-mail-white.svg" alt="" />
                    </div>
                    <div className="contact-item-content">
                      <h3>Our Address</h3>
                      <p>Thane Maharashtra, India. </p>
                    </div>
                  </div>
                  <div className="contact-info-item wow fadeInUp" data-wow-delay="0.8s">
                    <div className="icon-box">
                      <img src="images/icon-phone-white.svg" alt="" />
                    </div>
                    <div className="contact-item-content">
                      <h3>Contact Information</h3>
                      <p><Link to="tel:+9136392815">+ (91) 9136254875</Link></p>
                      {/* <p><Link to="tel:+9737955449">  + (91) 9737955449</Link></p> */}
                      <p><Link to="mailto:innosutraailimited@gmail.com">innosutraailimited@gmail.com</Link></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="contact-us-form">
                <div className="section-title">
                  <h2 className="wow fadeInUp" data-wow-delay="0.2s" data-cursor="-opaque">Get in touch <span>with us</span></h2>
                </div>
                <div className="contact-form wow fadeInUp" data-wow-delay="0.4s">
                  <form id="contactForm" action="#" method="POST" data-toggle="validator">
                    <div className="row">
                      <div className="form-group col-md-6 mb-4">
                        <label className="form-label">first name*</label>
                        <input type="text" name="fname" className="form-control" id="fname" placeholder="First Name" required />
                        <div className="help-block with-errors"></div>
                      </div>
                      <div className="form-group col-md-6 mb-4">
                        <label className="form-label">last name*</label>
                        <input type="text" name="lname" className="form-control" id="lname" placeholder="Last Name" required />
                        <div className="help-block with-errors"></div>
                      </div>
                      <div className="form-group col-md-6 mb-4">
                        <label className="form-label">mobile number*</label>
                        <input type="text" name="phone" className="form-control" id="phone" placeholder="Phone" required />
                        <div className="help-block with-errors"></div>
                      </div>
                      <div className="form-group col-md-6 mb-4">
                        <label className="form-label">email address*</label>
                        <input type="email" name="email" className="form-control" id="email" placeholder="Email" required />
                        <div className="help-block with-errors"></div>
                      </div>
                      <div className="form-group col-md-12 mb-5">
                        <label className="form-label">message</label>
                        <textarea name="message" className="form-control" id="message" rows="4"
                          placeholder="Enter Message Here..."></textarea>
                        <div className="help-block with-errors"></div>
                      </div>
                      <div className="col-md-12">
                        <button type="submit" className="btn-default"><span>Submit Message</span></button>
                        <div id="msgSubmit" className="h3 hidden"></div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            {/*  <div className="col-lg-12">
              <div className="google-map-iframe">
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d96737.10562045308!2d-74.08535042841811!3d40.739265258395164!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c24fa5d33f083b%3A0xc80b8f06e177fe62!2sNew%20York%2C%20NY%2C%20USA!5e0!3m2!1sen!2sin!4v1703158537552!5m2!1sen!2sin" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
              </div>
            </div> */}
          </div>
        </div>
      </div>
      <Footer />
    </>
  )
}
export default Contact
